import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { PartnerRoleConfig } from '../../models/partner.models';
import { PartnerStatusBanner } from '../../shared/partner-status-banner/partner-status-banner';
import { PartnerRoleConfigService } from '../../services/partner-role-config';

/**
 * Public pitch page for the Execution Partner program. No guard — anyone
 * can view it. Role cards link straight into the apply form with that role
 * pre-selected via a `?role=` query param (see partner.routes.ts — 'apply'
 * has no :role path segment, so query param is the non-breaking choice
 * that doesn't require touching the route config).
 *
 * Also hosts PartnerStatusBanner — a logged-in returning applicant sees
 * their approve/reject decision here even if they never bookmarked
 * /execution-partners/applied.
 */
@Component({
  selector: 'app-partner-landing',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, PartnerStatusBanner],
  templateUrl: './partner-landing.html',
  styleUrls: ['./partner-landing.css'],
})
export class PartnerLanding {
  private readonly roleConfig = inject(PartnerRoleConfigService);

  /** Drives the role cards grid — adding a role to
   *  PartnerRoleConfigService automatically shows up here, no template
   *  change needed. */
  readonly roles: PartnerRoleConfig[] = this.roleConfig.listRoles();
}